// frontend/src/components/mcbim/RotationControl.tsx
import React from "react";
import { ActionIcon, Group, NumberInput, Tooltip, rem } from "@mantine/core";
import { MdRotateLeft, MdRotateRight } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setRotationInRedux } from "../designSlice"; // juster sti ved behov

export const RotationControl: React.FC = () => {
  const dispatch = useAppDispatch();
  const rotation = useAppSelector((state) => state.design.rotation);

  const normalize = (value: number) => {
    // alltid 0–359
    return ((value % 360) + 360) % 360;
  };

  const handleInputChange = (value: string | number) => {
    if (typeof value !== "number" || Number.isNaN(value)) return;
    dispatch(setRotationInRedux(normalize(value)));
  };

  const step = (delta: number) => {
    dispatch(setRotationInRedux(normalize(rotation + delta)));
  };

  return (
    <Group gap="xs" align="center">
      <NumberInput
        value={normalize(rotation)}
        onChange={handleInputChange}
        size="sm"
        min={0}
        max={359}
        step={1}
        allowDecimal={false}
        clampBehavior="strict"
        suffix="°"
        aria-label="Rotasjon i grader"
        styles={{
          input: {
            width: rem(63), // kun plass til 3 tegn + °
            textAlign: "right",
            paddingRight: rem(18),
          },
        }}
      />

      <Tooltip label="Roter 1° mot venstre" position="bottom" withArrow>
        <ActionIcon
          size={34}
          radius="xl"
          variant="subtle"
          aria-label="Reduser rotasjon med 1 grad"
          onClick={() => step(-1)}
        >
          <MdRotateLeft size={16} />
        </ActionIcon>
      </Tooltip>

      <Tooltip label="Roter 1° mot høyre" position="bottom" withArrow>
        <ActionIcon
          size={34}
          radius="xl"
          variant="subtle"
          aria-label="Øk rotasjon med 1 grad"
          onClick={() => step(1)}
        >
          <MdRotateRight size={16} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
};
